export const BrandLogo = () => {
  return (
    <div className="flex-row-el flex-center w-full h-full gap-5">
      <img
        src="/icon.png"
        alt=""
        className="block h-[96px] w-auto object-contain"
      />
      <span
        className="text-[54px] text-[#2766A6]"
        style={{ fontFamily: "MPLUSRounded1c-Bold" }}
      >
        みまもり
      </span>
    </div>
  );
};
